export const handleReferences = data => {
  return Object.entries(data).reduce((prev, current) => {
    const [key, value] = current

    if (/origemId|livroReferencia|cursoReferencia/.test(key)) {
      return {
        ...prev,
        [key]: {
          value: (value || {})._id,
          label: (value || {}).titulo
        }
      }
    }

    return {
      ...prev,
      [key]: value
    }
  }, {})
}

export default handleReferences



// WEBPACK FOOTER //
// ./src/utils/formatReferenceToSelect.js